module.exports = __webpack_public_path__ + "static/media/Yandex.fc8c33db.svg";